import { I18NextPipe } from 'angular-i18next';
import { AccountType } from '../credential-forms.model';

export const ServiceEnpoint = {
  [AccountType.Public]: 'blob.core.windows.net',
  [AccountType.Germany]: 'blob.core.cloudapi.de',
  [AccountType.China]: 'blob.core.chinacloudapi.cn',
  [AccountType.Government]: 'blob.core.usgovcloudapi.net'
};

export const ServiceEnpointHints = {
  [AccountType.Public]: 'storages:addStorageAccountWizard.inputCredentialsStep.publicHint',
  [AccountType.Germany]: 'storages:addStorageAccountWizard.inputCredentialsStep.germanyHint',
  [AccountType.China]: 'storages:addStorageAccountWizard.inputCredentialsStep.chinaHint',
  [AccountType.Government]: 'storages:addStorageAccountWizard.inputCredentialsStep.governmentHint',
  [AccountType.AzureStack]: 'storages:addStorageAccountWizard.inputCredentialsStep.azureStackHint'
};

export const getAccountTypes = (i18n: I18NextPipe) => [
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.public'),
    value: AccountType.Public
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.azureStack'),
    value: AccountType.AzureStack
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.china'),
    value: AccountType.China
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.germany'),
    value: AccountType.Germany
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.government'),
    value: AccountType.Government
  }
];
